define('modules/htmlad/form/htmlad_form_model',['backbone',
  'jquery',
  '_',

  'modules/form/form_item_collection',
  'modules/form/form_section_model',

  'session'
], function (Backbone, $, _,
             FormItemCollection,
             FormSectionModel,
             session) {
  'use strict';
  var Model = Backbone.Model.extend({
    parse: function (response, options) {
      var respond = {},
        sections = new Backbone.Collection();

      _.forEach(response.sections, function (section) {
        var sectionModel = new FormSectionModel(section);

        var itemCollection = new FormItemCollection(section.fields);
        sectionModel.set({fields: itemCollection});
        sections.add(sectionModel);
      });

      delete response.sections;

      _.extend(respond, response);
      _.extend(respond, {sections: sections});

      return respond;
    },

    apiUrl: function (method, isPreview) {
      var apiUrl = session.get('apiUrl') + 'htmlad';

      if (isPreview) {
        apiUrl += '/preview';
      } else if (this.get('id')) {
        apiUrl += '/' + this.get('id');
      } else if (method !== 'create') {
        apiUrl += '/new';
      }

      if (this.get('params')) {
        apiUrl += '?' + $.param(this.get('params'));
      }
      return apiUrl;
    },

    sync: function (method, model, options) {
      options = options || {};
      options.url = this.apiUrl(method, model.get('_preview'));
      if(model.get('_preview')) {
        options.method = 'post';
      }
      model.unset('_preview', {silent: true});
      model.unset('params', {silent: true});

      return Backbone.sync.apply(this, arguments);
    },

    url: function () {
      return this.apiUrl('', false);
    }
  });

  return Model;
});

